import { Button, styled } from '@mui/material';

export const StyleButton = styled(Button)(({ theme }) => ({
  '.video-js &': {
    display: 'flex',
    position: 'absolute',
    left: '50%',
    height: 'auto',
    width: 'auto',
    transform: 'translateX(-50%)',
    bottom: '3.5em',
    borderRadius: 30,
    backgroundColor: '#0000007c',
    padding: '0.75em 1.75em',
    fontWeight: 500,
    fontSize: 24,

    [theme.breakpoints.down('lg')]: {
      fontSize: 21,
    },

    [theme.breakpoints.down('md')]: {
      fontSize: 18,
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },

  '.MuiButton-startIcon svg': {
    fontSize: '0.85em',
  },
}));
